import { Button } from "@/components/ui/button.tsx";
import { PlusIcon } from "@heroicons/react/20/solid";
import { HeaderSlot } from "@packages/core-client/components/HeaderSlot.tsx";
import { useI18nextInstance } from "@squide/i18next";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { i18NextInstanceKey } from "../../i18n/i18next.ts";

export function SegmentsHeading() {
    const i18nextInstance = useI18nextInstance(i18NextInstanceKey);
    const { t } = useTranslation("SegmentsHeading", { i18n: i18nextInstance });

    const navigate = useNavigate();
    const handleNewSegment = useCallback(() => navigate("/settings/segments/new"), [navigate]);

    return (
        <>
            <HeaderSlot>
                <Button intent="primary" size="sq-sm" aria-label={t("newSegment")} onPress={handleNewSegment} className="sm:hidden">
                    <PlusIcon aria-hidden="true" />
                </Button>
                <Button intent="primary" onPress={handleNewSegment} className="hidden sm:inline-flex">
                    <PlusIcon aria-hidden="true" />
                    {t("newSegment")}
                </Button>
            </HeaderSlot>

            <p className="text-muted-fg max-w-2xl">{t("description")}</p>
        </>
    );
}
